import { Chip } from '@mui/material';

export const StudentDetailsTableHeader = [
  {
    field: 'doa',
    headerName: 'Date Of Admission',
    width: 200, // Fixed pixel width
  },
  {
    field: 'name',
    headerName: 'Student Name',
    width: 200, // Fixed pixel width
  },
  {
    field: 'class_name',
    headerName: 'Class',
    width: 200, // Fixed pixel width
  },
  {
    field: 'activeCourseCount',
    headerName: 'Active Course',
    width: 150, // Fixed pixel width
  },
  {
    field: 'totalCourseCount',
    headerName: 'Total Course',
    width: 150, // Fixed pixel width
  },
  {
    field: 'totalSales',
    headerName: 'Total Sales',
    width: 150, // Fixed pixel width
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 130,
    renderCell: ({ value }) => (
      <Chip
        label={Boolean(value) ? 'Active' : 'Inactive'}
        variant="filled"
        color={Boolean(value) ? 'success' : 'error'}
      />
    ),
  },
];

export const studentStatus = [
  { id: -1, name: 'All' },
  { id: 'active', name: 'Active' },
  { id: 'inactive', name: 'Inactive' },
];
